<div *ngIf="loading" fxLayout="row" style="width: 100%; height: 100%;" fxLayoutAlign="center center">
  <mat-spinner></mat-spinner>
</div>